(function () {
  const root = document.querySelector('[data-origin-star-root]');
  if (!root) return;

const compactOriginStyleId = "fancying-origin-compact-intro";
if (!document.getElementById(compactOriginStyleId)) {
  const compactOriginStyle = document.createElement("style");
  compactOriginStyle.id = compactOriginStyleId;
  compactOriginStyle.textContent = `
    .origin-star-page .origin-hero {
      grid-template-columns: minmax(0, 1.1fr) minmax(220px, 320px) !important;
      gap: clamp(18px, 3vw, 34px) !important;
      min-height: auto !important;
      max-width: 1160px !important;
      margin: clamp(18px, 3vw, 34px) auto 0 !important;
      padding: clamp(20px, 3.2vw, 36px) clamp(18px, 3.6vw, 44px) !important;
    }
    .origin-star-page .origin-hero:before {
      display: none !important;
    }
    .origin-star-page .origin-hero:after {
      inset: 0 !important;
      border-radius: 20px !important;
      opacity: .48 !important;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, .08), 0 22px 70px rgba(0, 0, 0, .28) !important;
    }
    .origin-star-page .hero-copy {
      max-width: 660px !important;
      margin: 0 !important;
      text-align: left !important;
    }
    .origin-star-page .origin-hero .eyebrow {
      margin-bottom: 8px !important;
      font-size: .74rem !important;
    }
    .origin-star-page .origin-hero h1 {
      max-width: none !important;
      margin-bottom: 8px !important;
      font-size: clamp(1.45rem, 2.5vw, 2.35rem) !important;
      line-height: 1.05 !important;
    }
    .origin-star-page .origin-hero .subtitle {
      max-width: 560px !important;
      margin: 0 !important;
      font-size: clamp(.92rem, 1.25vw, 1.04rem) !important;
      line-height: 1.45 !important;
    }
    .origin-star-page .origin-hero .intro-text {
      max-width: 640px !important;
      margin: 12px 0 0 !important;
      gap: 5px !important;
      border-left: 1px solid rgba(255, 217, 79, .35) !important;
      border-top: 0 !important;
      padding: 2px 0 2px 16px !important;
      background: linear-gradient(90deg, rgba(255, 217, 79, .06), transparent 70%) !important;
    }
    .origin-star-page .origin-hero .intro-text p {
      color: rgba(251, 245, 234, .66) !important;
      font-size: .86rem !important;
      line-height: 1.38 !important;
    }
    .origin-star-page .hero-visual {
      display: block !important;
      min-height: auto !important;
      align-self: stretch !important;
    }
    .origin-star-page .hero-visual:before {
      display: none !important;
    }
    .origin-star-page .hero-visual > img {
      width: 100% !important;
      height: clamp(150px, 17vw, 220px) !important;
      border-radius: 14px !important;
      object-fit: cover !important;
      opacity: .78 !important;
      box-shadow: 0 18px 48px rgba(0, 0, 0, .34) !important;
    }
    .origin-star-page .portrait-card {
      display: none !important;
    }
    .origin-star-page .question-wheel-section {
      padding-top: clamp(22px, 4vw, 48px) !important;
    }
    @media (max-width: 740px) {
      .origin-star-page .origin-hero {
        grid-template-columns: 1fr !important;
        margin-top: 12px !important;
        padding: 20px 16px 18px !important;
      }
      .origin-star-page .origin-hero .intro-text {
        margin-top: 10px !important;
      }
      .origin-star-page .hero-visual {
        display: none !important;
      }
    }
  `;
  document.head.appendChild(compactOriginStyle);
}

const starField = root.querySelector("#starField");
const starCount = root.querySelector("#starCount");
const resetStars = root.querySelector("#resetStars");
const cosmicWord = root.querySelector("#cosmicWord");
const cosmicMeaning = root.querySelector("#cosmicMeaning");
const originLine = root.querySelector("#originLine");
const identityWord = root.querySelector("#identityWord");
const sentenceInput = root.querySelector("#identitySentence");
const sentenceCount = root.querySelector("#sentenceCount");
const selectedQuestionTitle = root.querySelector("#selectedQuestionTitle");
const selectedQuestionText = root.querySelector("#selectedQuestionText");
const selectedQuestionLine = root.querySelector("#selectedQuestionLine");

const resultName = root.querySelector("#resultName");
const resultDate = root.querySelector("#resultDate");
const resultPlace = root.querySelector("#resultPlace");
const resultWord = root.querySelector("#resultWord");
const resultOriginStar = root.querySelector("#resultOriginStar");
const resultGiftMessage = root.querySelector("#resultGiftMessage");
const resultCode = root.querySelector("#resultCode");
const resultSentence = root.querySelector("#resultSentence");
const shareOriginStar = root.querySelector("#shareOriginStar");
const shareGiftMessage = root.querySelector("#shareGiftMessage");
const wiseModal = root.querySelector("#wiseModal");
const wiseTrigger = root.querySelector("#wiseTrigger");
const wiseClose = root.querySelector("#wiseClose");
const wiseIntro = root.querySelector("#wiseIntro");
const wiseProducts = root.querySelector("#wiseProducts");
const wiseWhatsapp = root.querySelector("#wiseWhatsapp");
const saveOriginReading = root.querySelector("#saveOriginReading");
const archiveSaveStatus = root.querySelector("#archiveSaveStatus");
const originArchiveList = root.querySelector("#originArchiveList");
const originArchiveEmpty = root.querySelector("#originArchiveEmpty");
const clearOriginArchive = root.querySelector("#clearOriginArchive");
const engraveName = root.querySelector("#engraveName");
const engraveDate = root.querySelector("#engraveDate");
const engravePlace = root.querySelector("#engravePlace");
const engraveWord = root.querySelector("#engraveWord");
const engraveCode = root.querySelector("#engraveCode");
const pendantPreview = root.querySelector("#pendantPreview");
const whatsappNumber = "";
const ARCHIVE_KEY = "fancyingSecretOriginArchive";
const productDataNode = document.getElementById("originProductData");
let shopProductCatalog = [];

try {
  shopProductCatalog = productDataNode ? JSON.parse(productDataNode.textContent || "[]") : [];
} catch (error) {
  shopProductCatalog = [];
}

const energies = [
  "brave",
  "orbit",
  "golden",
  "silent",
  "flame",
  "lunar",
  "guardian",
  "radiant",
  "truth",
  "origin",
  "pure",
  "destiny",
  "echo",
  "sovereign",
];

const anchorStars = [
  { x: 12, y: 18, size: 7, energy: "brave" },
  { x: 22, y: 34, size: 5, energy: "orbit" },
  { x: 36, y: 21, size: 8, energy: "golden" },
  { x: 52, y: 16, size: 5, energy: "silent" },
  { x: 67, y: 28, size: 7, energy: "flame" },
  { x: 81, y: 18, size: 5, energy: "lunar" },
  { x: 17, y: 58, size: 8, energy: "guardian" },
  { x: 31, y: 72, size: 5, energy: "radiant" },
  { x: 43, y: 51, size: 7, energy: "truth" },
  { x: 59, y: 64, size: 8, energy: "origin" },
  { x: 73, y: 52, size: 5, energy: "pure" },
  { x: 88, y: 74, size: 7, energy: "destiny" },
  { x: 48, y: 84, size: 5, energy: "echo" },
  { x: 8, y: 82, size: 5, energy: "sovereign" },
];

function seededRandom(seed) {
  const x = Math.sin(seed) * 10000;
  return x - Math.floor(x);
}

function createStarData() {
  const generated = Array.from({ length: 224 }, (_, index) => ({
    x: 4 + seededRandom(index * 7.13) * 92,
    y: 5 + seededRandom(index * 13.91) * 88,
    size: 3 + seededRandom(index * 19.3) * 8.2,
    energy: energies[index % energies.length],
    twinkle: 1.8 + seededRandom(index * 23.7) * 4.8,
  }));

  return [...generated, ...anchorStars.map((star, index) => ({ ...star, twinkle: 2.4 + index * 0.16 }))];
}

const starData = createStarData();

function unique(values) {
  return [...new Set(values.filter(Boolean))];
}

const cosmicAdjectives = unique(`
Golden Silver Bright Brave Gentle Quiet Deep Warm Clear True Soft Calm Strong Kind Pure Lucky Happy Hopeful
Peaceful Radiant Shining Glowing Tender Steady Free Open Wild Wise Loved Chosen Safe Bold Sweet Light Hidden
Secret Dreamy Starry Moonlit Sunlit Cosmic Mystic Magic Inner Loyal Honest Patient Joyful Fresh New Ancient
Timeless Endless Far Near Rising Burning Blooming Guiding Healing Loving Fearless Graceful Serene Blue White
Rose Amber Pearl Crystal Velvet Snowy Fiery Starlit Wishful Grateful Mindful Rooted Grounded Protected Sheltered
Blessed Devoted Caring Centered Certain Creative Curious Daring Easy Honest Humble Inspired Peacefilled Playful
Ready Rested Royal Simple Sincere Still Trusting Worthy Young Alive Awake Balanced Beautiful Beloved Better
Blue Calm Close Cozy Daily Dear Fair First Good Great Growing Held High Human Last Long Low Near Noble Now
Personal Precious Proud Real Renewed Smooth Stable Summer Tenderhearted Thankful Thoughtful Vast Whole Newborn
Morning Evening Midnight Dawnlit Nightlit Misty Icy Sandy Floral Goldenbright Silversoft Clearblue Deepblue
Rosegold Warmgold Brightgold Softgold Snowwhite Moonwhite Starwhite Gentleblue Trueblue
Active Adventurous Cheerful Confident Courageous Delicate Earnest Elegant Faithful Friendly Generous Glad
Helpful Joyous Lasting Lively Powerful Resilient Romantic Secure Sensitive Spirited Sunny Upward Welcome
Comforting Natural Peacegiving Heartwarming Soulful
`.trim().split(/\s+/));

const simpleCosmicBodies = unique(`
Star Moon Sun Sky Dawn Night Light Fire Flame Spark Glow Path Road Bridge Gate Door Garden Flower Rose Ocean
Wave River Cloud Rain Snow Ice Wind Mountain Valley Desert Stone Jewel Pearl Crystal Gold Silver Heart Soul
Dream Hope Love Wish Promise Memory Truth Courage Grace Peace Joy Wonder Gift Home Shelter Harbor Compass
Beacon Lantern Mirror Crown Ring Orbit Comet Meteor Galaxy Nebula Aurora Horizon Eclipse Planet Field Bloom
Song Voice Echo Sign Code Key Map Journey Voyage Return Beginning Chapter Story Moment Destiny Fortune Focus
Balance Strength Wisdom Freedom Energy Calm Clarity Vision Protection Guardian Companion Belonging Legacy
North Sunrise Sunset Starlight Moonlight Sunlight Skyway Starway Moonpath Sunpath Dreamlight Hopelight Lovelight
Soulpath Heartlight Firelight Oceanlight Cloudlight Dawnlight Nightlight
`.trim().split(/\s+/));

const bodyRoots = `
Star Moon Sun Sky Dawn Dusk Night Cloud Storm Rain Snow Ice Frost Fire Flame Ember Ocean River Wave Tide Desert
Garden Flower Rose Pearl Crystal Gold Silver Aurora Comet Meteor Galaxy Nebula Horizon Orbit Light Mirror Halo
Crown Ring Compass Beacon Lantern North Sunrise Sunset Meadow Mountain Valley Stone Wind Bloom Seed Feather
Wing
`.trim().split(/\s+/);

const bodyEndings = `
light path song field stone bloom heart flame wave gate garden spark dream hope star moon sun sky cloud fire
glow shine bridge mirror ring crown compass beacon lantern flower pearl crystal jewel gift shelter wing trace
ray pulse echo wish promise memory grace peace joy wonder
`.trim().split(/\s+/);

function makeBody(root, ending) {
  return `${root}${ending[0].toUpperCase()}${ending.slice(1)}`;
}

const generatedBodies = bodyRoots.flatMap((root) => bodyEndings.map((ending) => makeBody(root, ending)));
const cosmicBodies = unique([...simpleCosmicBodies, ...generatedBodies]);
const cosmicDescriptors = cosmicAdjectives;

const meaningOpeners = [
  "The stars you chose suggest",
  "Your current constellation carries",
  "The field around you is reflecting",
  "This cosmic signal points toward",
  "Your three stars are gathering around",
  "The energy surrounding you right now reveals",
];

const meaningClosers = [
  "a season of movement through uncertainty with quiet courage.",
  "a reminder that what belongs to you is beginning to orbit closer.",
  "the part of you that has survived distance, darkness, and change.",
  "a soft but unmistakable signal to trust the path opening ahead.",
  "a moment where your inner world is becoming visible in form.",
  "the promise that your arrival does not need to be rushed.",
  "a kind of protection that feels calm, personal, and deeply remembered.",
  "the beauty of becoming more yourself after every crossing.",
];

const descriptorReadings = [
  {
    match: ["lit", "bright", "Light", "Dawn", "Sun", "Solar", "Radiant", "Lucid"],
    gift: "illumination",
    guidance: "let one clear truth become visible before you make the next move",
    shadow: "do not confuse being seen with being understood",
  },
  {
    match: ["Moon", "Lunar", "Night", "Nocturne", "Dream", "Whisper", "Veil"],
    gift: "intuition",
    guidance: "listen to the quiet signal that arrives before logic explains it",
    shadow: "do not hide your needs behind mystery",
  },
  {
    match: ["forged", "Fire", "Flame", "Ember", "Phoenix", "Meteor", "Burning"],
    gift: "transformation",
    guidance: "trust what has been strengthened by pressure, heat, and time",
    shadow: "do not turn every challenge into a battle",
  },
  {
    match: ["held", "guided", "blessed", "shielded", "Shelter", "Sanctuary", "Guardian"],
    gift: "protection",
    guidance: "allow yourself to be supported while you cross this threshold",
    shadow: "do not mistake protection for staying still",
  },
  {
    match: ["woven", "bound", "Thread", "Silk", "Velvet", "Promise", "Vow"],
    gift: "connection",
    guidance: "notice the people, places, and memories that keep pulling meaning together",
    shadow: "do not bind yourself to what no longer returns your energy",
  },
  {
    match: ["born", "made", "raised", "risen", "Newborn", "Origin", "Seed", "Root"],
    gift: "rebirth",
    guidance: "begin again without asking the past for permission",
    shadow: "do not rush the fragile first stage of becoming",
  },
  {
    match: ["Gold", "Golden", "Crown", "Noble", "Sovereign", "Worthy", "Chosen"],
    gift: "self-worth",
    guidance: "stand closer to the version of yourself that already knows its value",
    shadow: "do not perform confidence when what you need is tenderness",
  },
  {
    match: ["Ocean", "Tide", "River", "Wave", "Rose", "Tender", "Mercy", "Grace"],
    gift: "emotional flow",
    guidance: "let feeling move through you instead of becoming a place you live forever",
    shadow: "do not let softness become self-erasure",
  },
];

const symbolReadings = [
  {
    match: ["Orbit", "Path", "Compass", "Bridge", "Gate", "Portal", "Voyage", "Journey", "Horizon"],
    gift: "direction",
    guidance: "your next step does not need to be dramatic; it only needs to be true",
    shadow: "do not wait for the whole map before taking the first step",
  },
  {
    match: ["Star", "Beacon", "Light", "Ray", "Spark", "Halo", "Lantern"],
    gift: "visibility",
    guidance: "let your presence become a signal rather than a performance",
    shadow: "do not dim yourself to make the room easier for others",
  },
  {
    match: ["Guardian", "Shelter", "Protection", "Sanctuary", "Temple", "Talisman", "Charm"],
    gift: "safety",
    guidance: "choose what protects your energy, not just what impresses the world",
    shadow: "do not close the gate to everything just because one thing hurt you",
  },
  {
    match: ["Mirror", "Truth", "Clarity", "Vision", "Archive", "Code", "Key"],
    gift: "recognition",
    guidance: "look directly at what is real; the answer is already forming there",
    shadow: "do not use analysis to avoid the feeling underneath",
  },
  {
    match: ["Flame", "Fire", "Nova", "Comet", "Meteor", "Pulse", "Energy"],
    gift: "activation",
    guidance: "move while the inner flame is awake; momentum is part of the message",
    shadow: "do not burn through your reserves to prove your strength",
  },
  {
    match: ["Moon", "Crescent", "Eclipse", "Stillness", "Calm", "Peace", "Whisper"],
    gift: "restoration",
    guidance: "let quietness become a source of power, not a sign of absence",
    shadow: "do not disappear when you actually want to be held",
  },
  {
    match: ["Crown", "Sovereignty", "Will", "Victory", "Strength", "Courage"],
    gift: "agency",
    guidance: "reclaim authorship over the chapter you are entering",
    shadow: "do not confuse control with devotion to your path",
  },
  {
    match: ["Memory", "Return", "Echo", "Legacy", "Soul", "Kinship", "Belonging"],
    gift: "remembrance",
    guidance: "something from your past is not pulling you backward; it is asking to be integrated",
    shadow: "do not romanticize what taught you pain",
  },
];

const TOTAL_COSMIC_WORDS = cosmicDescriptors.length * cosmicBodies.length;

let selectedStars = [];
let selectedIntent = "self";
let selectedQuestion = "health";
let selectedDiyType = "card";
let wiseShownForCurrentReading = false;
let currentReading = {
  word: "A Door Is Opening",
  originStar: "Waiting for your stars",
  giftMessage: "Choose three stars to reveal a message for this moment.",
  theme: "luck",
  products: [],
};

function titleCase(value) {
  return value
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0].toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
}

function escapeHTML(value) {
  return String(value || "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  })[character]);
}

function readArchive() {
  try {
    const parsed = JSON.parse(localStorage.getItem(ARCHIVE_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

function writeArchive(items) {
  try {
    localStorage.setItem(ARCHIVE_KEY, JSON.stringify(items.slice(0, 40)));
    return true;
  } catch (error) {
    return false;
  }
}

function formatArchiveDate(value) {
  try {
    return new Intl.DateTimeFormat("en", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }).format(new Date(value));
  } catch (error) {
    return value;
  }
}

function renderArchive() {
  if (!originArchiveList || !originArchiveEmpty) return;
  const items = readArchive();
  originArchiveList.innerHTML = "";
  originArchiveEmpty.hidden = items.length > 0;
  if (clearOriginArchive) clearOriginArchive.hidden = items.length === 0;

  items.forEach((item) => {
    const card = document.createElement("article");
    card.className = "origin-archive-card";
    card.innerHTML = `
      <div>
        <span>${escapeHTML(formatArchiveDate(item.savedAt))}</span>
        <strong>${escapeHTML(item.word || item.originStar || "Origin Star")}</strong>
        <p>${escapeHTML(item.giftMessage || "")}</p>
      </div>
      <dl>
        <div><dt>Question</dt><dd>${escapeHTML(item.question || "Origin Star")}</dd></div>
        <div><dt>Intent</dt><dd>${escapeHTML(item.intent || "Personal")}</dd></div>
        <div><dt>Stars</dt><dd>${escapeHTML((item.stars || []).join(" / "))}</dd></div>
      </dl>
      <button type="button" data-delete-archive="${escapeHTML(item.id)}">Delete</button>
    `;
    originArchiveList.append(card);
  });
}

function saveCurrentReading() {
  if (selectedStars.length !== 3) return;
  const item = {
    id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
    savedAt: new Date().toISOString(),
    word: currentReading.word,
    originStar: currentReading.originStar,
    giftMessage: currentReading.giftMessage,
    theme: currentReading.theme,
    intent: intentCopy[selectedIntent].label,
    question: questionTopics[selectedQuestion].label,
    stars: selectedStars.map((index) => String(index + 1)),
    reading: cosmicMeaning ? cosmicMeaning.textContent.replace(/\s+/g, " ").trim() : "",
  };
  const saved = writeArchive([item, ...readArchive()]);

  if (archiveSaveStatus) {
    archiveSaveStatus.textContent = saved ? "Saved." : "Unable to save on this browser.";
    window.setTimeout(() => {
      archiveSaveStatus.textContent = "";
    }, 2600);
  }
  renderArchive();
}

function updateQuestionDisplay() {
  const topic = questionTopics[selectedQuestion] || questionTopics.health;
  if (selectedQuestionTitle) selectedQuestionTitle.textContent = topic.label;
  if (selectedQuestionText) selectedQuestionText.textContent = topic.text;
  if (selectedQuestionLine) selectedQuestionLine.textContent = `Your reading is currently focused on ${topic.label}.`;
  root.querySelectorAll("[data-question]").forEach((button) => {
    const active = button.dataset.question === selectedQuestion;
    button.classList.toggle("is-active", active);
    button.setAttribute("aria-pressed", active ? "true" : "false");
  });
}

function createStars() {
  starField.innerHTML = "";
  starData.forEach((star, index) => {
    const button = document.createElement("button");
    button.type = "button";
    button.className = "star-button";
    button.style.left = `${star.x}%`;
    button.style.top = `${star.y}%`;
    button.style.setProperty("--size", `${star.size}px`);
    button.style.setProperty("--twinkle", `${star.twinkle}s`);
    button.setAttribute("aria-label", `Choose star ${index + 1}`);
    button.dataset.index = String(index);
    button.addEventListener("click", () => toggleStar(index));
    starField.append(button);
  });
}

function hashSelectedStars() {
  return selectedStars
    .slice()
    .sort((a, b) => a - b)
    .reduce((total, index, position) => {
      const star = starData[index];
      return total + (index + 11) * (position + 3) * 997 + Math.round(star.x * 17 + star.y * 31 + star.size * 101);
    }, 0);
}

function findReading(word, readings) {
  return readings.find((reading) =>
    reading.match.some((item) => word.toLowerCase().includes(item.toLowerCase())),
  ) || readings[0];
}

const intentCopy = {
  self: {
    label: "Your Origin Star",
    meaning: "This reading is for your own path. It reflects the part of you that is learning to become visible, steady, and real.",
    message: "Wear this as a reminder that your light does not need permission.",
  },
  love: {
    label: "Their Origin Star",
    meaning: "This reading is for someone held close to your heart. It turns the stars you chose into a quiet blessing for connection, memory, and devotion.",
    message: "A star for the one whose presence feels like home.",
  },
  blessing: {
    label: "Blessing Star",
    meaning: "This reading is for a wish you want to send forward. It carries protection, hope, and the belief that good things can still arrive.",
    message: "May this star carry light toward the life waiting ahead.",
  },
};

const questionTopics = {
  health: {
    label: "Health & Energy",
    theme: "healing",
    text: "Ask about your body, stress, healing rhythm, and the energy you need to protect.",
    hint: "Your question is centered on your body, rest, stress, and the kind of energy your life is asking you to protect.",
    guidance: "treat your energy as information, not inconvenience",
  },
  career: {
    label: "Career Direction",
    theme: "wealth",
    text: "Ask about work, purpose, visibility, and the next professional step that deserves your focus.",
    hint: "Your question is centered on work, ambition, timing, and the version of you that wants a clearer direction.",
    guidance: "choose the next step that builds authority instead of only reducing pressure",
  },
  money: {
    label: "Money & Abundance",
    theme: "wealth",
    text: "Ask about income, security, opportunity, and your relationship with receiving more.",
    hint: "Your question is centered on money, stability, opportunity, and the decisions that shape your sense of abundance.",
    guidance: "make room for receiving without ignoring the practical plan",
  },
  dating: {
    label: "Love & Dating",
    theme: "love",
    text: "Ask about attraction, emotional availability, timing, and whether a connection is worth opening to.",
    hint: "Your question is centered on attraction, emotional availability, and whether a connection has enough truth to continue.",
    guidance: "watch consistency more closely than chemistry",
  },
  marriage: {
    label: "Marriage & Commitment",
    theme: "love",
    text: "Ask about commitment, shared future, repair, trust, and the promise that needs clarity.",
    hint: "Your question is centered on commitment, trust, shared future, and the emotional contract between two people.",
    guidance: "let devotion be measured by steadiness, not only intensity",
  },
  family: {
    label: "Fertility & Family",
    theme: "healing",
    text: "Ask about fertility, pregnancy hopes, caregiving, family bonds, or a new chapter that needs tenderness.",
    hint: "Your question is centered on family, caregiving, fertility, belonging, or a new beginning that needs tenderness.",
    guidance: "protect softness while still telling the truth",
  },
  travel: {
    label: "Travel & Relocation",
    theme: "luck",
    text: "Ask about movement, relocation, timing, distance, and whether a new place is calling you.",
    hint: "Your question is centered on movement, relocation, travel timing, and the pull of a new environment.",
    guidance: "notice whether the destination expands you or only helps you escape",
  },
  home: {
    label: "Home & Property",
    theme: "wealth",
    text: "Ask about moving, buying, renting, renovating, and the home that can support your next era.",
    hint: "Your question is centered on property, home, stability, and the place that can hold your next chapter.",
    guidance: "choose the option that supports your nervous system as much as your future plan",
  },
  negotiation: {
    label: "Negotiation",
    theme: "wealth",
    text: "Ask about offers, deals, interviews, important conversations, and the courage to ask for what fits your value.",
    hint: "Your question is centered on offers, deals, interviews, conversations, and the courage to claim your value.",
    guidance: "ask from clarity, not from the fear of losing the room",
  },
};

const themeProducts = {
  wealth: [
    {
      name: "Golden Orbit Bracelet",
      purpose: "For ambition, money pressure, and the desire to feel steady while moving upward.",
      series: "引力·能量",
      href: "#",
    },
    {
      name: "North Star Pendant",
      purpose: "For focus, career direction, and the quiet confidence to be seen.",
      series: "孤星·悦己",
      href: "#",
    },
  ],
  love: [
    {
      name: "Star-Plucking Necklace",
      purpose: "For love that wants to be remembered, named, and held close.",
      series: "摘星·唯一",
      href: "#",
    },
    {
      name: "Promise Meteorite Pair",
      purpose: "For anniversaries, long-distance love, and the wish to make devotion visible.",
      series: "摘星·唯一",
      href: "#",
    },
  ],
  healing: [
    {
      name: "Quiet Moon Bracelet",
      purpose: "For emotional recovery, health wishes, and returning to yourself gently.",
      series: "引力·能量",
      href: "#",
    },
    {
      name: "Shelter Star Charm",
      purpose: "For protection, rest, and the feeling of being held through change.",
      series: "孤星·悦己",
      href: "#",
    },
  ],
  luck: [
    {
      name: "Lucky Meteorite Ring",
      purpose: "For timing, good fortune, and a signal that better things are allowed to arrive.",
      series: "引力·能量",
      href: "#",
    },
    {
      name: "Wish Star Identity Card",
      purpose: "For gifting a blessing, preserving a wish, or marking a new beginning.",
      series: "宇宙身份卡",
      href: "#",
    },
  ],
  recognition: [
    {
      name: "Radiance Meteorite Pendant",
      purpose: "For reputation, visibility, and stepping into a life that can recognize you back.",
      series: "孤星·悦己",
      href: "#",
    },
    {
      name: "Crown Star Bracelet",
      purpose: "For confidence, leadership, and the courage to stop hiding your value.",
      series: "引力·能量",
      href: "#",
    },
  ],
};

const themeProductKeywords = {
  wealth: ["wealth", "power", "focus", "ambition", "fortune", "prosperity", "tiger", "citrine", "command", "gravity"],
  love: ["love", "destiny", "heart", "connection", "promise", "passion", "red", "soul", "sanctuary"],
  healing: ["healing", "protection", "calm", "peace", "warmth", "hope", "gentle", "moon", "shelter", "balance"],
  luck: ["luck", "lucky", "fortune", "wish", "guidance", "star", "hope", "orbit", "possibilities", "light"],
  recognition: ["confidence", "courage", "strength", "radiant", "shine", "direction", "clarity", "wisdom", "sovereignty", "forward"],
};

function productVisualFromTitle(title) {
  const value = title.toLowerCase();
  if (value.includes("bracelet")) return "bracelet";
  if (value.includes("ring")) return "ring";
  if (value.includes("earring")) return "pair";
  if (value.includes("card")) return "card";
  if (value.includes("charm")) return "charm";
  return "necklace";
}

function normalizeShopProduct(product) {
  const productTags = product.tags || "";
  return {
    name: product.title,
    purpose: productTags
      ? `Selected from the Fancying Secret collection for this signal. Related energy: ${productTags}.`
      : "Selected from the Fancying Secret product collection for your current Origin Star signal.",
    series: "Fancying Secret",
    price: product.price,
    image: product.image,
    visual: productVisualFromTitle(product.title || ""),
    href: product.url || "#",
  };
}

function selectCatalogProducts(theme, seed) {
  if (!shopProductCatalog.length) return themeProducts[theme] || themeProducts.luck;
  const keywords = themeProductKeywords[theme] || themeProductKeywords.luck;
  const scored = shopProductCatalog
    .filter((product) => product && product.title && product.url)
    .map((product, index) => {
      const haystack = `${product.title || ""} ${product.tags || ""}`.toLowerCase();
      const score = keywords.reduce((total, keyword) => total + (haystack.includes(keyword) ? 1 : 0), 0);
      return { product, score, index };
    })
    .sort((a, b) => b.score - a.score || ((a.index + seed) % 17) - ((b.index + seed) % 17));

  const primary = scored.filter((item) => item.score > 0);
  const pool = primary.length >= 2 ? primary : scored;
  const start = pool.length ? seed % pool.length : 0;
  const picked = [];
  for (let offset = 0; offset < pool.length && picked.length < 2; offset += 1) {
    const item = pool[(start + offset) % pool.length];
    if (item && !picked.some((product) => product.url === item.product.url)) {
      picked.push(normalizeShopProduct(item.product));
    }
  }
  return picked.length ? picked : themeProducts[theme] || themeProducts.luck;
}

function readingTheme(descriptorReading, symbolReading) {
  const gifts = `${descriptorReading.gift} ${symbolReading.gift}`.toLowerCase();
  if (/self-worth|agency|visibility|recognition/.test(gifts)) return "recognition";
  if (/connection|remembrance|devotion/.test(gifts)) return "love";
  if (/restoration|protection|emotional|rebirth/.test(gifts)) return "healing";
  if (/activation|direction|illumination/.test(gifts)) return "wealth";
  return "luck";
}

const themeHints = {
  wealth: "A part of you may be asking for progress, security, or a clearer path forward.",
  love: "A part of you may be asking whether a connection is safe, real, or worth holding closer.",
  healing: "A part of you may be asking for rest, protection, or a gentler way through pressure.",
  luck: "A part of you may be waiting for timing to change, or for a door to open at the right moment.",
  recognition: "A part of you may be ready to be seen, chosen, or taken seriously.",
};

const themeSignals = {
  wealth: [
    "A Door Is Opening",
    "Move Before You Feel Ready",
    "Your Next Step Matters",
    "The Money Path Is Clearing",
    "Bet On Your Own Work",
    "Focus Brings Fortune",
    "The Timing Is Warming Up",
    "Build It Anyway",
    "Your Effort Wants Direction",
    "Do Not Miss The Signal",
    "Green Light Ahead",
    "Momentum",
    "Say Yes To The Better Offer",
    "Money Likes A Clear Plan",
    "Choose The Bigger Life",
    "Work Smarter, Not Smaller",
    "Your Value Is Rising",
    "The Next Move Pays Off",
    "Stop Waiting For Perfect",
    "A Practical Miracle",
    "Follow The Open Door",
    "The Long Game Is Working",
    "Your Luck Needs Action",
    "Invest In The Future You",
    "Small Steps, Big Return",
    "Keep Building",
    "The Path Is Getting Wider",
    "One Brave Move",
    "Make Room For More",
    "Worth The Risk",
  ],
  love: [
    "Love Needs Clarity",
    "Say The Quiet Thing",
    "A Bond Wants Truth",
    "Choose What Feels Safe",
    "The Heart Already Knows",
    "Closer, But Softer",
    "Do Not Chase The Unclear",
    "Let Love Be Simple",
    "This Connection Has A Question",
    "Protect The Tender Part",
    "No More Guessing",
    "Choose The One Who Shows Up",
    "Soft But Certain",
    "The Right Love Feels Calm",
    "Say What You Mean",
    "A Heart Check",
    "Let The Truth Be Kind",
    "Love Should Not Feel Like A Test",
    "The Door Is Half Open",
    "Stay Where You Are Valued",
    "A Real Yes",
    "Do Not Beg For Warmth",
    "Meet In The Middle",
    "What Is Meant Will Stay",
    "Let It Be Mutual",
    "The Heart Wants Honesty",
    "A Soft Answer Is Coming",
    "Choose Peace Over Pulling",
    "The Feeling Is Not Random",
    "Closer To Truth",
  ],
  healing: [
    "Rest Is Also Progress",
    "Come Back To Yourself",
    "Protect Your Peace",
    "You Are Allowed To Pause",
    "The Pressure Is Not Forever",
    "Choose The Gentle Way",
    "Your Body Wants Quiet",
    "Let The Weight Leave Slowly",
    "Healing Comes In Waves",
    "You Do Not Have To Rush",
    "Breathe First",
    "Your Peace Is The Plan",
    "Slow Is Still Forward",
    "Less Noise, More Truth",
    "Choose Yourself Gently",
    "The Soft Reset",
    "Put The Weight Down",
    "Your Nervous System Knows",
    "Health Is A Kind Of Wealth",
    "Leave Room To Recover",
    "A Quiet Comeback",
    "Do Less, Feel More",
    "You Are Not Behind",
    "Let The Body Speak",
    "Gentle Power",
    "Come Home To Yourself",
    "Pause Without Guilt",
    "The Storm Is Passing",
    "Peace Before Proof",
    "You Can Start Again",
  ],
  luck: [
    "Trust The Quiet Sign",
    "Your Luck Is Turning",
    "A Small Door May Open",
    "Good Timing Is Near",
    "Keep Your Wish Alive",
    "Something Better Can Arrive",
    "The Sign Is Subtle",
    "Let The Universe Surprise You",
    "Not All Hope Is Loud",
    "A Chance Is Moving Closer",
    "Right Place, Right Time",
    "A Good Sign",
    "The Window Is Opening",
    "Watch The Coincidence",
    "Say Yes To The Spark",
    "A Lucky Turn",
    "The Small Yes Matters",
    "Something Is Aligning",
    "Keep The Wish Warm",
    "Good News Has A Path",
    "The Universe Winks Back",
    "Almost There",
    "A Chance Encounter",
    "The Door Knows Your Name",
    "Hope Gets A Signal",
    "Take The Hint",
    "A Bright Little Omen",
    "The Timing Is Kind",
    "Stay Open",
    "Fortune Favors Motion",
  ],
  recognition: [
    "Step Into The Light",
    "Stop Hiding Your Value",
    "Let Yourself Be Seen",
    "Your Name Wants Space",
    "Claim The Room Softly",
    "You Are More Ready Than You Think",
    "Do Not Shrink Here",
    "The Spotlight Can Be Gentle",
    "Your Work Wants Witness",
    "Stand Where You Belong",
    "Main Character Energy",
    "Your Name Has Weight",
    "Take Up Space",
    "Be Seen, Not Chosen Last",
    "Claim The Room",
    "Confidence Is Returning",
    "Let Them Notice",
    "The Stage Is Not Too Big",
    "No More Hiding",
    "Own The Moment",
    "A Quiet Crown",
    "Your Voice Matters",
    "Stop Apologizing For Shine",
    "The Room Can Hold You",
    "Show Up Bigger",
    "You Are Ready Enough",
    "Visibility Without Fear",
    "Stand Tall",
    "The Light Fits You",
    "Let Your Work Speak",
  ],
};

function chooseSignal(seed, theme) {
  const signals = themeSignals[theme] || themeSignals.luck;
  return signals[Math.floor(seed / 13) % signals.length];
}

function renderReading({ signal, descriptorReading, symbolReading, theme, topic }) {
  const copy = intentCopy[selectedIntent];
  const topicCopy = topic || questionTopics.health;
  return `
    <div class="reading-card">
      <p><strong>Star Reading.</strong> ${topicCopy.hint} ${themeHints[theme]} This may be something you have been carrying quietly, even if you have not named it directly.</p>
      <p><strong>Star Symbol.</strong> "${signal}" reflects ${descriptorReading.gift} meeting ${symbolReading.gift} inside your ${topicCopy.label.toLowerCase()} question; it points to the place where your desire and your hesitation are both present.</p>
      <p><strong>Current Guidance.</strong> ${topicCopy.guidance}; ${descriptorReading.guidance}; ${symbolReading.guidance}. ${copy.message}</p>
    </div>
  `;
}

function chooseWord() {
  const seed = hashSelectedStars();
  const adjective = cosmicDescriptors[seed % cosmicDescriptors.length];
  const body = cosmicBodies[Math.floor(seed / cosmicDescriptors.length) % cosmicBodies.length];
  const descriptorReading = findReading(adjective, descriptorReadings);
  const symbolReading = findReading(body, symbolReadings);
  const copy = intentCopy[selectedIntent];
  const topic = questionTopics[selectedQuestion] || questionTopics.health;
  const theme = topic.theme || readingTheme(descriptorReading, symbolReading);
  const signal = chooseSignal(seed, theme);
  const originStar = signal;
  const giftMessage = `${signal}. For your ${topic.label.toLowerCase()} question: ${topic.guidance}. ${copy.message}`;

  return {
    word: signal,
    originStar,
    giftMessage,
    theme,
    question: topic.label,
    products: selectCatalogProducts(theme, seed),
    meaning: renderReading({ signal, descriptorReading, symbolReading, theme, topic }),
  };
}

function updateStars() {
  root.querySelectorAll(".star-button").forEach((button) => {
    const index = Number(button.dataset.index);
    const selected = selectedStars.includes(index);
    button.classList.toggle("is-selected", selected);
    button.classList.toggle("is-disabled", selectedStars.length === 3 && !selected);
  });

  starCount.textContent = `${selectedStars.length} / 3 stars selected`;

  if (selectedStars.length === 3) {
    const result = chooseWord();
    currentReading = result;
    wiseShownForCurrentReading = false;
    cosmicWord.textContent = result.word;
    originLine.textContent = `${result.question} / ${intentCopy[selectedIntent].label}`;
    cosmicMeaning.innerHTML = result.meaning;
    wiseTrigger.hidden = false;
    wiseTrigger.classList.add("is-visible");
    if (saveOriginReading) {
      saveOriginReading.hidden = false;
      saveOriginReading.classList.add("is-visible");
    }
    if (archiveSaveStatus) archiveSaveStatus.textContent = "";
    identityWord.value = result.word;
    updateIdentityPreview();
  } else {
    currentReading = {
      word: "A Door Is Opening",
      originStar: "Choose stars, or write your own",
      giftMessage: "The star message is optional. You can choose three stars as a starter memory for the NFC card, or leave the card open for your own video, voice, webpage, or note.",
      theme: questionTopics[selectedQuestion].theme,
      question: questionTopics[selectedQuestion].label,
      products: themeProducts[questionTopics[selectedQuestion].theme] || themeProducts.luck,
    };
    cosmicWord.textContent = "Choose three stars";
    originLine.textContent = `${questionTopics[selectedQuestion].label} / Your Origin Star will appear after you choose three stars.`;
    cosmicMeaning.textContent = questionTopics[selectedQuestion].text;
    wiseTrigger.hidden = true;
    wiseTrigger.classList.remove("is-visible");
    if (saveOriginReading) {
      saveOriginReading.hidden = true;
      saveOriginReading.classList.remove("is-visible");
    }
    if (archiveSaveStatus) archiveSaveStatus.textContent = "";
    updateIdentityPreview();
  }
}

function renderWiseProducts() {
  const topic = questionTopics[selectedQuestion] || questionTopics.health;
  wiseIntro.textContent = `${topic.label}: ${topic.text} ${themeHints[currentReading.theme] || themeHints.luck}`;
  const whatsappText = [
    "Hi Fancying Secret, I want a personal Origin Star reading.",
    `Question: ${topic.label}`,
    `Cosmic Signal: ${currentReading.word}`,
    `Origin Star: ${currentReading.originStar}`,
    `Theme: ${currentReading.theme}`,
    "Please recommend a product and explain what suits my current energy.",
  ].join("\n");
  const whatsappBase = whatsappNumber
    ? `https://wa.me/${whatsappNumber}?text=`
    : "https://api.whatsapp.com/send?text=";
  wiseWhatsapp.href = `${whatsappBase}${encodeURIComponent(whatsappText)}`;
  wiseProducts.innerHTML = "";
  currentReading.products.forEach((product) => {
    const link = document.createElement("a");
    link.className = "wise-product";
    link.href = product.href;
    link.setAttribute("aria-label", `View ${product.name}`);
    link.innerHTML = `
      <div class="wise-product-media wise-product-media--${product.visual || "pendant"}" aria-hidden="true">
        ${product.image ? `<img src="${escapeHTML(product.image)}" alt="" loading="lazy" />` : "<i></i>"}
      </div>
      <span class="wise-product-series">${escapeHTML(product.series)}</span>
      <strong class="wise-product-title">${escapeHTML(product.name)}</strong>
      <p class="wise-product-purpose">${escapeHTML(product.purpose)}</p>
      <div class="wise-product-footer">
        <b>${escapeHTML(product.price || "$59.90")}</b>
        <em>View piece</em>
      </div>
    `;
    wiseProducts.append(link);
  });
}

function openWiseCounsel() {
  if (!wiseModal || selectedStars.length !== 3) return;
  renderWiseProducts();
  wiseShownForCurrentReading = true;
  wiseModal.classList.add("is-open");
  wiseModal.setAttribute("aria-hidden", "false");
}

function closeWiseCounsel() {
  wiseModal.classList.remove("is-open");
  wiseModal.setAttribute("aria-hidden", "true");
}

function toggleStar(index) {
  if (selectedStars.includes(index)) {
    selectedStars = selectedStars.filter((item) => item !== index);
  } else if (selectedStars.length < 3) {
    selectedStars = [...selectedStars, index];
  }
  updateStars();
}

function formatDateForDisplay(value) {
  if (!value) return "06.15.2026";
  const [year, month, day] = value.split("-");
  return `${month}.${day}.${year}`;
}

function dateCode(value) {
  if (!value) return "0615";
  const [, month, day] = value.split("-");
  return `${month}${day}`;
}

function placeCode(value) {
  if (!value.trim()) return "LA";
  return value
    .trim()
    .split(/[\s,.-]+/)
    .filter(Boolean)
    .slice(0, 3)
    .map((part) => part[0].toUpperCase())
    .join("");
}

function wordCode(value) {
  if (!value.trim()) return "GO";
  return value
    .trim()
    .split(/[\s,.-]+/)
    .filter(Boolean)
    .slice(0, 3)
    .map((part) => part[0].toUpperCase())
    .join("");
}

function nameCode(value) {
  return (value.trim() || "Emma").replace(/[^a-z0-9]/gi, "").toUpperCase().slice(0, 10) || "EMMA";
}

function engraveLine(value, maxLength) {
  const clean = value.trim().replace(/\s+/g, " ").toUpperCase();
  if (clean.length <= maxLength) return clean;
  return `${clean.slice(0, maxLength - 3)}...`;
}

function limitSentenceWords() {
  const words = sentenceInput.value.trim().split(/\s+/).filter(Boolean);
  if (words.length > 30) {
    sentenceInput.value = words.slice(0, 30).join(" ");
  }
  const count = sentenceInput.value.trim() ? sentenceInput.value.trim().split(/\s+/).length : 0;
  sentenceCount.textContent = `${count} / 30 words`;
}

function updateIdentityPreview() {
  const name = root.querySelector("#identityName").value.trim() || "Emma";
  const date = root.querySelector("#identityDate").value;
  const place = root.querySelector("#identityPlace").value.trim() || "Los Angeles";
  const word = identityWord.value.trim() || "A Door Is Opening";
  const sentence =
    sentenceInput.value.trim() || "I choose the star that remembers how far I have come.";

  resultName.textContent = name;
  resultDate.textContent = formatDateForDisplay(date);
  resultPlace.textContent = place;
  resultWord.textContent = titleCase(word);
  resultOriginStar.textContent = currentReading.originStar;
  resultGiftMessage.textContent = currentReading.giftMessage;
  shareOriginStar.textContent = currentReading.originStar;
  shareGiftMessage.textContent =
    selectedStars.length === 3
      ? `${currentReading.giftMessage} You can save this as the first NFC memory, or replace it with any personal content after receiving the card.`
      : currentReading.giftMessage;
  resultSentence.textContent = sentence;
  const code = `FS-${nameCode(name)}-${dateCode(date)}-${placeCode(place)}-${wordCode(word)}`;
  resultCode.textContent = code;
  engraveName.textContent = nameCode(name);
  engraveDate.textContent = formatDateForDisplay(date);
  engravePlace.textContent = engraveLine(place, 14);
  engraveWord.textContent = engraveLine(titleCase(word), 17);
  engraveCode.textContent = engraveLine(code, 22);
}

resetStars.addEventListener("click", () => {
  selectedStars = [];
  updateStars();
});

sentenceInput.addEventListener("input", () => {
  limitSentenceWords();
  updateIdentityPreview();
});

root.querySelectorAll(".identity-form input").forEach((input) => {
  input.addEventListener("input", updateIdentityPreview);
});

root.querySelectorAll("[data-shape]").forEach((button) => {
  button.addEventListener("click", () => {
    root.querySelectorAll("[data-shape]").forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");
    pendantPreview.classList.remove("pendant-round", "pendant-square", "pendant-oval");
    pendantPreview.classList.add(`pendant-${button.dataset.shape}`);
  });
});

root.querySelectorAll("[data-intent]").forEach((button) => {
  button.addEventListener("click", () => {
    selectedIntent = button.dataset.intent;
    root.querySelectorAll("[data-intent]").forEach((item) => item.classList.remove("is-active"));
    root.querySelectorAll(`[data-intent="${selectedIntent}"]`).forEach((item) => item.classList.add("is-active"));
    updateStars();
  });
});

root.querySelectorAll("[data-question]").forEach((button) => {
  button.addEventListener("click", () => {
    selectedQuestion = button.dataset.question || "health";
    selectedStars = [];
    updateQuestionDisplay();
    updateStars();
    const starSection = root.querySelector(".star-ritual");
    if (starSection) {
      starSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  });
});

root.querySelectorAll("[data-diy-type]").forEach((button) => {
  button.addEventListener("click", () => {
    selectedDiyType = button.dataset.diyType;
    root.querySelectorAll("[data-diy-type]").forEach((item) => item.classList.remove("is-active"));
    button.classList.add("is-active");
    root.dataset.diyType = selectedDiyType;
  });
});

wiseClose.addEventListener("click", closeWiseCounsel);
wiseTrigger.addEventListener("click", openWiseCounsel);
wiseModal.addEventListener("click", (event) => {
  if (event.target === wiseModal) closeWiseCounsel();
});

root.querySelector("#generateIdentity").addEventListener("click", updateIdentityPreview);

if (saveOriginReading) {
  saveOriginReading.addEventListener("click", saveCurrentReading);
}

if (originArchiveList) {
  originArchiveList.addEventListener("click", (event) => {
    const button = event.target.closest("[data-delete-archive]");
    if (!button) return;
    const id = button.getAttribute("data-delete-archive");
    writeArchive(readArchive().filter((item) => item.id !== id));
    renderArchive();
  });
}

if (clearOriginArchive) {
  clearOriginArchive.addEventListener("click", () => {
    writeArchive([]);
    renderArchive();
  });
}

root.dataset.diyType = selectedDiyType;
updateQuestionDisplay();
createStars();
updateStars();
limitSentenceWords();
updateIdentityPreview();
renderArchive();

})();
